import { render } from "./NetworkIcon.vue?vue&type=template&id=3bb6a72c&bindings={}"
import script from "./NetworkIcon.vue?vue&type=script&lang=ts"
export * from "./NetworkIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script